function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#4B4B4F",
  strokeLinecap: "round",
  strokeWidth: 3,
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.072 17.348c1.145 1.33 2.64 2.388 4.42 2.995 5.329 1.817 11.12-1.028 12.938-6.356.608-1.782.684-3.61.33-5.329M22.427 3.963c-1.136-1.292-2.608-2.319-4.353-2.915C12.746-.769 6.953 2.076 5.136 7.404c-.595 1.746-.682 3.538-.353 5.228",
  transform: "translate(1 1)"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinejoin: "round",
  d: "M20.148 12.925L24.607 8.466 29.066 12.925M9.418 8.466L4.96 12.925.5 8.466",
  transform: "translate(1 1)"
}));

var SvgRandom = function SvgRandom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRandom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/random.072cb702.svg";
export { ForwardRef as ReactComponent };